import React from "react";
import { OrderedListOutlined } from "@ant-design/icons";
import { DataTable } from "./DataTable";
import { YhBox } from "@components/YhBox";
import { Button } from "antd";
import { useUserModel } from "../userModel";
import { EditModeType } from "@src/types/FmsTypes";
import { IMdUserDetail } from "../UserTypes";
import { YhAuth } from "@src/components/auth/YhAuth";

export const DataBox = () => {
    const { syncData, setEditType, setDrawerVisible, exportUser, exportLoading,updateUserOrg,setTransferVisible } = useUserModel();

    const onDetail = (type: EditModeType) => {
        setDrawerVisible(true)
        setEditType(type)
    }
    const action = (
        <>
            {/* <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => syncData()}
            >同步</Button> */}
            <YhAuth resCode="portal2.au.user.ad">
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={() => onDetail('add')}
                >新增</Button>
            </YhAuth>
            <YhAuth resCode="portal2.au.user.ex">
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    loading={exportLoading}
                    onClick={() => exportUser()}
                >{exportLoading ? "导出中" : "导出"}</Button>
            </YhAuth>
            <YhAuth resCode="portal2.au.user.upOrg">
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={() => updateUserOrg()}
                >更新用户组织机构</Button>
            </YhAuth>
            <YhAuth resCode="portal2.au.user.tf">
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={() => setTransferVisible(true)}
                >部门迁移</Button>
            </YhAuth>
        </>
    );

    return (
        <YhBox title={<OrderedListOutlined />} action={action}>
            <DataTable />
        </YhBox>
    )
}